import {logger, Util} from 'yougile-util'
import {ClientUtilities} from '@client/client-utilities'
import {Backend} from './backend'
import {UtilUi} from './utils-ui'

export const VIDEO_PREVIEW_SIZE = 320

const waitFor = async (
  executor: (resolve: () => void) => void
): Promise<void> => {
  let success = false
  return Promise.race([
    new Promise<void>(ok => {
      executor(ok)
      success = true
    }),
    Util.wait(3_000).then(() => {
      if (!success) {
        logger.error('waitFor timeout', new Error().stack)
      }
    })
  ])
}

export class VideoPreview {
  static async createPreview(url: string): Promise<string | undefined> {
    const canvas = document.createElement('canvas')
    const video = document.createElement('video')
    video.src = url

    await waitFor(_ => video.addEventListener('loadedmetadata', _))

    const size = VIDEO_PREVIEW_SIZE
    const w = size
    const h = (size * video.videoHeight) / video.videoWidth

    video.width = w
    video.height = h
    canvas.width = w
    canvas.height = h
    video.currentTime = Math.min(1, video.duration * 0.5)

    await waitFor(_ => video.addEventListener('seeked', _))

    canvas.getContext('2d')?.drawImage(video, 0, 0, w, h)
    const blob = await UtilUi.canvasToBlob(canvas, 'image/png')
    const file = new File([blob], 'preview.png')
    const previewUrl = await ClientUtilities.saveFile({file})
    return previewUrl
  }

  static getVideoPreviewUrl(href: string): string {
    if (!href.includes('preview=')) {
      return ''
    }
    const uuid = href.split('preview=').pop()?.split('&')[0]
    return Backend.toDataUrl(`/user-data/${uuid}/preview.png`)
  }
}
